import { computed, inject, Injectable } from '@angular/core'
import { Category } from '../models/auth.model'
import { AuthService } from './auth.service'
import { environment } from '@environments/environment'

@Injectable({ providedIn: 'root' })
export class PermissionService {
  public readonly hasEditRights = computed(() => this.hasGroup('ALB_ALBERT_E_'))
  public readonly hasViewRights = computed(() => this.hasGroup('ALB_ALBERT_V_'))
  public readonly hasRedactRights = computed(() => this.hasGroup('ALB_ALBERT_REDACT_'))
  public readonly hasAdminRights = computed(() => {
    return this.hasGroup('ALB_ALBERT_ADMIN')
  })
  private readonly authService = inject(AuthService)
  public readonly userGroups = computed(() => {
    if (!this.authService.isAuthenticated()) {
      return []
    }
    return this.authService.userData()?.groups ?? []
  })
  public readonly hasBaseAccess = computed(() => {
    const requiredGroup = environment.requiredBaseGroup
    return this.userGroups().includes(requiredGroup)
  })

  public canEdit(category: Category | null): boolean {
    if (category === null || category === undefined) {
      return false
    }
    return this.hasEditRights() && this.hasGroup(`ALB_ALBERT_E_${category}`)

  }

  public canView(category: Category | null): boolean {
    if (category === null) {
      return false
    }
    return (this.hasViewRights() && this.hasGroup(`ALB_ALBERT_V_${category}`)) || this.hasGroup(`ALB_ALBERT_E_${category}`)
  }

  private hasGroup(groupName: string): boolean {
    return this.userGroups().some(g => g.startsWith(groupName))
  }
}
